export const aside = {
    back: {
        title: "Retournez à vos plannings",
        label: "Retour aux plannings"
    }
}